import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import SrOnly from 'ds/SrOnly'

import Flex from 'ds/Flex'

const SIZE = 56
const GAP = 30

const PaymentProcessorsWrapper = styled(Flex).attrs(() => ({
	flow: 'row nowrap',
	justify: 'initial',
}))`
	margin: 24px 0px;
	position: relative;
	left: -7px;
	& > * {
		margin-left: ${GAP}px;
	}

	& svg {
		display: block;
		width: ${SIZE}px;
		height: ${SIZE}px;
	}
`

const carouselTransition = {
	type: 'tween',
	ease: 'linear',
	duration: 16,
	repeat: Infinity,
}

const ItemWrapper = ({ children, fullWidth }) => (
	<motion.div
		animate={{
			x: [0, -fullWidth],
		}}
		transition={{ ...carouselTransition, duration: (fullWidth / 1000) * 25 }}
		style={{ width: SIZE, height: SIZE }}
	>
		<motion.div
			whileHover={{
				scale: 1.2,
			}}
			transition={{ type: 'spring', damping: 20, stiffness: 100, restDelta: 0.001 }}
		>
			{children}
		</motion.div>
	</motion.div>
)

const Item = ({ logo, name, fullWidth }) => (
	<ItemWrapper fullWidth={fullWidth}>
		{logo} <SrOnly>{name}</SrOnly>
	</ItemWrapper>
)

const IconCarousel = ({ icons }) => {
	const fullWidth = icons.length * (SIZE + GAP)

	return (
		<PaymentProcessorsWrapper>
			{icons.map(({ name, logo }) => (
				<Item key={name} logo={logo} name={name} fullWidth={fullWidth} />
			))}

			{/* Overscan for the carousel */}
			{icons.map(({ name, logo }) => (
				<Item key={`overscan-${name}`} logo={logo} name={name} fullWidth={fullWidth} />
			))}

			{icons.map(({ name, logo }) => (
				<Item key={`overscan-${name}`} logo={logo} name={name} fullWidth={fullWidth} />
			))}
		</PaymentProcessorsWrapper>
	)
}

export default IconCarousel
